import {SvgFunction, SvgProps} from "@web-libs/ui/svgs/types";
import {createHOC} from "@web-libs/util/hocs/create-hoc";
import {WithColorSvgFunction} from "@web-libs/ui/svgs/fill/with-color";
import {Color} from "@web-libs/features/colors/application/colors";

type BasicSvgProps = Omit<SvgProps, 'fill'>;

type WithClickPropsForSvg = BasicSvgProps & {
    onClick: () => void;
    fill: string;
}

export type WithClickPropsForWithColor = BasicSvgProps & {
    color?: Color;
    onClick: () => void;
}

// Overloads for _WithClick function
function _WithClick(svgFunction: SvgFunction): (props: WithClickPropsForSvg) => JSX.Element;
function _WithClick(svgFunction: WithColorSvgFunction): (props: WithClickPropsForWithColor) => JSX.Element;

function _WithClick(svgFunction: SvgFunction | WithColorSvgFunction) {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
        const {onClick, ...rest} = props;
        return <div style={{display:"inline", cursor:"pointer", ...(props.style ?? {})}} onClick={onClick}>
            {svgFunction(rest)}
        </div>
    }
}

export const withClick = createHOC("WithClick", _WithClick)
